module.exports = __webpack_public_path__ + "static/media/call5.94264673.png";